// extracted by mini-css-extract-plugin
module.exports = {"container":"HighlightRipple_container__2Pzeq","ripple":"HighlightRipple_ripple__3aIDM"};